import { Switch, type SwitchProps } from '@progress/kendo-react-inputs'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import { Typography } from '~/components/elements/Typography'
import { useLogEvent } from '~/hooks/useLogEvent'

import { isChartMaxUnifiedAtom } from '../../atoms'

import styles from './UnifyMaxSwitch.css'

export const UnifyMaxSwitch = () => {
  const { t } = useTranslation()
  const [isChartMaxUnified, setIsChartMaxUnified] = useAtom(
    isChartMaxUnifiedAtom,
  )

  const logEvent = useLogEvent()
  const handleSwitchChange = React.useCallback<EH<SwitchProps, 'onChange'>>(
    (event) => {
      const isChartMaxUnified = event.target.value
      setIsChartMaxUnified(isChartMaxUnified)
      logEvent(`${isChartMaxUnified ? 'Unify' : 'Diverse'} scale of graph`)
    },
    [logEvent, setIsChartMaxUnified],
  )

  return (
    <HStack align="center" spacing={1}>
      <Typography variant="normal" whiteSpace="noWrap">
        {t('fix_yaxis')}
      </Typography>

      <Switch
        checked={isChartMaxUnified}
        className={styles.switch}
        offLabel=""
        onChange={handleSwitchChange}
        onLabel=""
      />
    </HStack>
  )
}
